const getEnv = () => {
  const env = import.meta.env.VITE_CURRENT_ENV;
  switch (env) {
    case 'api':
      return 'production';
    case 'test':
    case 'stage':
    case 'dea':
      return env;
    case 'dev':
    default:
      return 'development';
  }
};
export { getEnv };
